import { basicBaseApi } from "./basicBaseApi";
import { Methods } from '@newview/infrastructure';


export class ShareroadtoinstitutionApi extends basicBaseApi {

  public get ControllerName(): any {
    return 'shareroadtoinstitution'
  }
  /**
   * 批量保存组织结构配置线路
   * @param projectDataId 
   * @param params 
   */
  public configRoadForBInstitution(institutioninId,params){
    return this.send(params,"configRoadForBInstitution?institutioninId="+institutioninId,Methods.POST)
  }
  /**
   * 查询组织结构配置线路
   * @param projectDataId 
   */
  public queryRoadForBInstitution(institutioninId){
    return this.send({institutioninId:institutioninId},"queryRoadForBInstitution",Methods.GET)
  }
  /**
   * 查询用户登录信息
   * @param institutioninId 
   * @returns 
   */
  public getRoadInfor(institutioninId){
    return this.send({institutioninId:institutioninId},"getRoadInfor",Methods.GET)
  }
  /**
   * 返回用户线路信息
   */
  public getBaseRoadInfor(institutioninId){
    return this.send({institutioninId:institutioninId},"getBaseRoadInfor",Methods.GET)
  }
  /**
   *FId 查询线路信息及对应的坐标点 
   * @param fId 
   * @returns 
   */
  public getRoadInfoByFId(fId,institutionId){
    return this.send({fId:fId,institutionId:institutionId},"getRoadInfoByFId",Methods.GET)
  }
}